
import * as CONST from 'common/const';
import createReducer from './createReducer';

const initialState = {
    loading: false,
    jobsData: [],
    error: '',
    initialized: false
}

export default createReducer(initialState, {
    [CONST.FETCH_JOBS_REQUEST]: state => ({
        ...state,
        loading: true,
        error: '',
        jobsData: [],
        initialized: true
    }),

    [CONST.FETCH_JOBS_SUCCESS]: (state, action) => ({
        ...state,
        loading: false,
        error: '',
        jobsData: action.jobsData,
        initialized: true
    }),

    [CONST.SAVE_JOBS_SUCCESS]: (state, action) => {
        const newJobsData = [...state.jobsData];
        const inContext = newJobsData.filter(x => x.id === action.id)[0];
        const ind = newJobsData.indexOf(inContext);
        const replacement = {...inContext};
        replacement.calculationDetails = JSON.parse(action.newCalcData);
        newJobsData[ind] = replacement
        return {
            ...state,
            loading: false,
            error: '',
            jobsData: newJobsData,
            initialized: true
        };
    },

    [CONST.FETCH_JOBS_FAILURE]: (state, action) => ({
        ...state,
        loading: false,
        jobsData: [],
        error: action.payload,
        initialized: false
    }),
});
